module.exports = __webpack_public_path__ + "img/P26-en.d2d58ac5.png";